"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Poland = void 0;
exports.Poland = {
    id: 'poland',
    companyName: 'Poland',
    transportModes: ['sea'],
    freightGate: {
        isOnboarded: false,
        realm: 'poland',
    },
    isInternal: true,
    isActive: true,
    countries: ['PL'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9sYW5kLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2FnZW50cy9kYXRhL1BvbGFuZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLE1BQU0sR0FBVTtJQUN6QixFQUFFLEVBQUUsUUFBUTtJQUNaLFdBQVcsRUFBRSxRQUFRO0lBQ3JCLGNBQWMsRUFBRSxDQUFDLEtBQUssQ0FBQztJQUN2QixXQUFXLEVBQUU7UUFDVCxXQUFXLEVBQUUsS0FBSztRQUNsQixLQUFLLEVBQUUsUUFBUTtLQUNsQjtJQUNELFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDO0NBQ3BCLENBQUEifQ==